import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { keys, pick, values } from 'lodash-es';
import { Typography } from './Typography';

const useFontStyle = makeStyles((theme: Theme) =>
  createStyles({
    bold: {
      fontWeight: 'bold',
    },
    success: {
      color: theme.palette.success.main,
    },
    error: {
      color: theme.palette.error.main,
    },
  }),
);

type ClassName = keyof ReturnType<typeof useFontStyle>;

type FontProps = {
  [key in ClassName]?: boolean;
};

export type FontStyleProps = FontProps & {
  color?:
    | 'initial'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'textPrimary'
    | 'textSecondary'
    | 'error';
  paragraph?: boolean;
  className?: string;
};

export const FontStyle: React.FunctionComponent<FontStyleProps> = ({
  children,
  className = '',
  paragraph,
  color,
  ...props
}) => {
  const classes = useFontStyle();
  const classNames = (keys(classes) as ClassName[]).filter((key) => props[key]);
  const filteredClasses = values(pick(classes, ...classNames));
  return (
    <Typography
      className={filteredClasses.concat(className).join(' ').trimEnd()}
      component='span'
      color={color}
      paragraph
    >
      {children}
    </Typography>
  );
};
